import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import IconArrowLeftApollo from 'yoda-core-components/lib/assets/svg/IconArrowLeftApollo.svg';
import HambCloseApollo from 'yoda-core-components/lib/assets/svg/CloseIcon_2022.svg';
import ScrollLockHOCFactory from 'yoda-core-components/lib/hoc/ScrollLockHOC/ScrollLockHOC';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './CAMSlidePanel.css';

const cx = classNames.bind(styles);

// TODO: Explore options to have one jsx file
export class CAMSlidePanel extends Component {
    static propTypes = {
        isOpenPanel: PropTypes.bool,
        onClosePanel: PropTypes.func,
        onPrimaryCloseButtonClick: PropTypes.func.isRequired,
        onCloseTransitionEnd: PropTypes.func,
        onOpenTransitionEnd: PropTypes.func,
        panelTitle: PropTypes.string,
        children: PropTypes.element,
        deviceType: PropTypes.oneOfType([PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
        panelTitleAlignment: PropTypes.oneOf(['default', 'right']),
        isPrimaryCloseButtonRequired: PropTypes.bool,
        hideBackArrowCloseButton: PropTypes.bool,
        restrictOutSideClickClose: PropTypes.bool,
        showBackIcon: PropTypes.bool,
        panelTitleClassName: PropTypes.string,
        panelIconComponent: PropTypes.any,
        closeIconComponent: PropTypes.any,
        isNative: PropTypes.bool,
        patchHeader: PropTypes.func,
        shouldHandleNativeBackBtn: PropTypes.bool,
    };

    static defaultProps = {
        isOpenPanel: false,
        panelTitle: '',
        children: '',
        panelIconComponent: <IconArrowLeftApollo />,
        closeIconComponent: <HambCloseApollo />,
        panelTitleAlignment: 'default',
        onCloseTransitionEnd: null,
        onOpenTransitionEnd: null,
        deviceType: {},
        isPrimaryCloseButtonRequired: false,
        hideBackArrowCloseButton: false,
        restrictOutSideClickClose: false,
        onClosePanel: () => {},
        showBackIcon: true,
        panelTitleClassName: '',
        isNative: false,
        patchHeader: () => {},
        shouldHandleNativeBackBtn: false,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.closePanel = this.closePanel.bind(this);
        this.onCloseTransitionEnd = this.onCloseTransitionEnd.bind(this);
        this.onOpenTransitionEnd = this.onOpenTransitionEnd.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);
        this.onPrimaryCloseButtonClick = this.onPrimaryCloseButtonClick.bind(this);
        this.state = {
            // This state represents if the panel was completely closed (after transition)
            closed: !props.isOpenPanel,
        };
    }

    componentDidMount() {
        if (!this.state.closed) {
            this.patchNativeHeader(false);
        }
        const { isNative, shouldHandleNativeBackBtn } = this.props;
        if (isNative && shouldHandleNativeBackBtn) {
            document.removeEventListener('nativeAppBackPress', this.onPrimaryCloseButtonClick);
            document.addEventListener('nativeAppBackPress', this.onPrimaryCloseButtonClick);
        }
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isOpenPanel && !this.props.isOpenPanel) {
            this.setState({
                closed: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpenPanel !== this.props.isOpenPanel) {
            this.props.isOpenPanel ? this.patchNativeHeader(false) : this.patchNativeHeader(true);
        }
    }

    componentWillUnmount() {
        this.patchNativeHeader(true);
        const { isNative, shouldHandleNativeBackBtn } = this.props;
        if (isNative && shouldHandleNativeBackBtn) {
            document.removeEventListener('nativeAppBackPress', this.closePanel);
        }
    }

    onOpenTransitionEnd() {
        if (typeof this.props.onOpenTransitionEnd === 'function') {
            this.props.onOpenTransitionEnd();
        }
    }

    onCloseTransitionEnd() {
        this.setState({
            closed: true,
        });

        if (typeof this.props.onCloseTransitionEnd === 'function') {
            this.props.onCloseTransitionEnd();
        }
    }

    onTransitionEnd() {
        this.props.isOpenPanel ? this.onOpenTransitionEnd() : this.onCloseTransitionEnd();
    }

    onPrimaryCloseButtonClick(e) {
        e.preventDefault();
        this.props.onPrimaryCloseButtonClick(e);
    }

    getStyleToogleWrapper() {
        // styling
        const toggleWrapperStyle = dt([
            'w-full',
            'h-full',
            'fixed',
            'sm:z-[100]',
            'top-0',
            'left-0',
            'invisible',
            'opacity-0',
        ]);
        const activeToggleWrapperStyle = dt([
            'w-full',
            'h-full',
            'fixed',
            'sm:z-[100]',
            'top-0',
            'left-0',
            'visible',
            'opacity-1',
        ]);

        const toogleWrapper = this.props.isOpenPanel
            ? `${styles.toggleWrapper} ${activeToggleWrapperStyle}`
            : `${styles.toggleWrapper} ${toggleWrapperStyle}`;
        return toogleWrapper;
    }

    getStyleTooglePanel() {
        // styling
        const detailsPanelStyle = dt([
            'fixed',
            'top-0',
            'sm:z-[101]',
            'bg-white',
            'h-full',
            'lg:w-[422px]',
            'right-0',
            'md:w-[392px]',
            'sm:w-full',
        ]);

        const tooglePanel = this.props.isOpenPanel
            ? `${detailsPanelStyle} ${styles.detailsPanel} ${styles.activeDetailsPanel}`
            : `${detailsPanelStyle} ${styles.detailsPanel}`;
        return tooglePanel;
    }

    patchNativeHeader(backButton = false) {
        const { isNative, shouldHandleNativeBackBtn } = this.props;
        isNative &&
            shouldHandleNativeBackBtn &&
            this.props.patchHeader({
                backButton,
            });
    }

    closePanel(e) {
        e.preventDefault();
        this.props.onClosePanel(e);
    }

    render() {
        const {
            panelTitleAlignment,
            isPrimaryCloseButtonRequired,
            hideBackArrowCloseButton,
            restrictOutSideClickClose,
            showBackIcon,
            panelTitleClassName,
            isOpenPanel,
            panelIconComponent,
            closeIconComponent,
        } = this.props;

        // styling
        const panelHeaderStyle = dt([
            'bg-white',
            'text-small',
            'text-white',
            'py-3',
            'px-4',
            'w-full',
            'sm:z-[102]',
            'h-12',
            'relative',
            'border-b',
            'border-solid',
            'border-gray-15',
        ]);
        const panelBackIconStle = dt(['pt-1.5']);
        const panelHeaderTextStyle = dt([
            'absolute',
            'left-1/2',
            '-translate-x-1/2',
            'text-black',
            'w-full',
            'text-center',
        ]);
        const panelTitleStyle = dt([
            'inline-block',
            'text-large',
            'text-black',
            'font-open-sans-semibold',
            '-mt-1',
        ]);
        const panelIconStyle = dt(['fill-white']);
        const panelContentStyle = dt(['overflow-auto', 'sm:z-[101]', 'h-full', 'relative', 'pb-6']);
        const closeIconStyle = dt([
            'cursor-pointer',
            'text-white',
            'inline-block',
            'absolute',
            'sm:right-[18px]',
            'top-2',
            'stroke-2',
        ]);

        return (
            <div className={cx(styles.cover)}>
                <button
                    type="button"
                    className={this.getStyleToogleWrapper()}
                    onClick={
                        !restrictOutSideClickClose &&
                        (isPrimaryCloseButtonRequired
                            ? this.onPrimaryCloseButtonClick
                            : this.closePanel)
                    }
                />
                <div
                    data-automation-id="at-active-panel"
                    className={cx(this.getStyleTooglePanel(), {
                        'animate-on-load': isOpenPanel,
                    })}
                    onTransitionEnd={this.onTransitionEnd}
                    onAnimationEnd={this.onTransitionEnd}
                >
                    <div
                        className={cx(
                            styles.panelHeader,
                            panelHeaderStyle,
                            `panel-title-${panelTitleAlignment}`
                        )}
                    >
                        {!hideBackArrowCloseButton && (
                            <>
                                <a
                                    /* eslint-disable no-script-url */
                                    href="javascript:void(0)"
                                    className={cx('backIcon', 'panelBackIcon', panelBackIconStle)}
                                    onClick={
                                        showBackIcon ? this.closePanel : (e) => e.preventDefault()
                                    }
                                    data-automation-id="at-slide-back-button"
                                >
                                    {showBackIcon && (
                                        <Icon
                                            iconType="svg"
                                            width="24px"
                                            height="24px"
                                            viewBox="0 0 24 24"
                                            pathClassName={panelIconStyle}
                                        >
                                            {panelIconComponent}
                                        </Icon>
                                    )}
                                </a>
                                <a
                                    /* eslint-disable no-script-url */
                                    href="javascript:void(0)"
                                    className={cx(
                                        'backIcon',
                                        'panelHeaderText',
                                        panelHeaderTextStyle
                                    )}
                                    onClick={
                                        showBackIcon ? this.closePanel : (e) => e.preventDefault()
                                    }
                                    data-automation-id="at-slide-back-button"
                                >
                                    <span
                                        data-automation-id="at-panel-title"
                                        className={cx(
                                            styles.panelTitle,
                                            panelTitleStyle,
                                            panelTitleClassName
                                        )}
                                        tabIndex={-42}
                                    >
                                        {this.props.panelTitle}
                                    </span>
                                </a>
                            </>
                        )}
                        {isPrimaryCloseButtonRequired && (
                            <a
                                href=""
                                className={`${styles.closeIcon} ${closeIconStyle}`}
                                onClick={this.onPrimaryCloseButtonClick}
                                data-automation-id="at-primary-close-button"
                            >
                                <Icon
                                    iconType="svg"
                                    width="32px"
                                    height="32px"
                                    viewBox="0 0 32 32"
                                    pathClassName={`${styles.closeIcon} ${closeIconStyle}`}
                                >
                                    {closeIconComponent}
                                </Icon>
                            </a>
                        )}
                    </div>
                    {!this.state.closed ? (
                        <div
                            data-automation-id="at-panel-content"
                            id="atPanelContent"
                            className={cx('panelContent', panelContentStyle)}
                        >
                            {this.props.children}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default ScrollLockHOCFactory('isOpenPanel')(CAMSlidePanel);
